import React, { useContext } from "react";

const ConfigContext = React.createContext([]);

const ConfigContextProvider = ({ children }) => {
  const all = {
    location: {
      defaultRange: '9999',
    }
  }

  const local = {
    debug: true,
    host: 'https://uwtrefpunt.lndo.site',
  };

  const acceptance = {
    debug: true,
    host: 'https://acceptatie.uwtrefpunt.nl',
  };

  const production = {
    debug: false,
    host: 'https://www.uwtrefpunt.nl',
  };

  let config = process.env.NODE_ENV === 'production' ? production : acceptance;

  if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('lndo.site') !== -1) {
    config = local;
    console.log('Local environment detected. Using local settings.');
  } else if (window.location.hostname.indexOf('acceptatie') !== -1) {
    config = acceptance;
    console.log('Staging environment detected. Using development settings.');
  }

  config = { ...config, ...all };

  return <ConfigContext.Provider value={ config }>{ children }</ConfigContext.Provider>
}

export function useConfig() {
  return useContext(ConfigContext);
}

export default ConfigContextProvider;
